var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuntosInteres2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 341.77 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271,389.42a236.37,236.37,0,0,0-39-9.93c9.12-10.71,18.84-22.59,28.6-35.28,53.86-70,81.16-128.33,81.16-173.32C341.77,76.66,265.11,0,170.88,0S0,76.66,0,170.88c0,45.25,27.31,103.65,81.16,173.56,9.72,12.62,19.39,24.42,28.48,35.07a236.41,236.41,0,0,0-38.88,9.91c-40.63,14.52-49.16,34-49.16,47.82s8.53,33.3,49.16,47.81c27,9.64,62.53,14.95,100.12,14.95S244,494.69,271,485.05c40.63-14.51,49.16-34,49.16-47.81S311.64,403.94,271,389.42ZM29.3,170.88C29.3,92.81,92.81,29.3,170.88,29.3S312.47,92.81,312.47,170.88c0,37.79-25.89,91.45-74.87,155.19a955.45,955.45,0,0,1-66.74,77.33,947.7,947.7,0,0,1-66.49-76.83C55.26,262.81,29.3,209,29.3,170.88ZM261.16,457.46c-23.89,8.54-56,13.24-90.28,13.24S104.5,466,80.61,457.46C59,449.73,50.9,441,50.9,437.24S59,424.75,80.61,417c14.77-5.27,32.66-9.07,52.28-11.21,15.91,17.37,26.92,28.14,27.77,29l10.25,10,10.22-10c.85-.83,11.81-11.6,27.67-29,19.65,2.14,37.57,5.94,52.36,11.22,21.64,7.74,29.71,16.51,29.71,20.23S282.8,449.73,261.16,457.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.18,142.34a10,10,0,0,0-19,6.13,62,62,0,1,1-42.3-40.66,10,10,0,1,0,5.37-19.27,82,82,0,1,0,56,53.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.19,109.63l-.09-.09A10,10,0,0,0,214,123.68l.09.09a10,10,0,0,0,14.14-14.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuntosInteres2);
export default __webpack_public_path__ + "static/media/Puntos-interes2.6299b31ed2c6f57a2fddce4bb1ddecf3.svg";
export { ForwardRef as ReactComponent };